<template>
    <div>
    <app-toolbarcustom app_title="Peraturan Perusahaan" app_menu="bot"></app-toolbarcustom>
    <v-card flat>
        <v-list two-line>
            <v-subheader></v-subheader>
            <template v-for="(item, index) in filteredposts">
                <v-list-item
                  :key="item.text"
                  @click="GoTo(item.url)"
                >
                  <v-list-item-avatar>
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                v-if="index + 1 < filteredposts.length"
                :key="index"
              ></v-divider>
           </template>
        </v-list>
    </v-card>
    </div>
</template>
<script>
    export default {
        data: () => ({
            loading: false,
            posts: [
                {icon: 'folder', text: 'Peraturan Perusahaan', description: 'Peraturan Perusahaan', url:'notavailable',company: 'ALL'},
                {icon: 'folder', text: 'COC', description: 'Code of Conduct', url:'notavailable',company: 'ALL'},
                {icon: 'folder', text: 'OJK - PPDP', description: 'Kompilasi Peraturan PPDP', url:'ppdp',company: 'ALL'},
            ]
        }),
        computed: {
            filteredposts() {
                return this.posts.filter(post => {
                    if (this.$functions.UsersCompany() !== '') {
                        return post.company === 'ALL' || post.company === this.$functions.UsersCompany()
                    } else {
                        return post
                    }
                }
                )
            },
        },
        methods: {
            GoTo (url) {
                if (url === 'notavailable') {
                    alert('Coming Soon')
                } else if (url === 'ppdp') {
                    window.open('https://linktr.ee/KompilasiPeraturanPPDP', '_blank', 'noopener,noreferrer')
                } else {
                    this.$router.push(url)
                }
            }
        }
    }
</script>